import { FC, memo } from 'react'
import { useFormContext } from '../forms/form'
import FieldError, { useFieldValidity } from './fieldError'

interface MultiSelectInputProps {
    label: string
    value: string
    options: string[]
    onChange: (e: React.ChangeEvent<HTMLSelectElement>) => void
    required?: boolean
    helperText?: string
}

const MultiSelectInput: FC<MultiSelectInputProps> = ({ 
    label, 
    value, 
    options, 
    onChange, 
    required = false,
    helperText
}) => {
    const { disableInputs, isLoading } = useFormContext()
    const { errorMessage, fieldClassName, onBlur, onChange: onValidityChange, onInvalid } = useFieldValidity()

    return (
        <div className="input-holder">
            <label>{label}{required ? '*' : ''}</label>
            <select
                value={value}
                onChange={(e) => {
                    onValidityChange(e)
                    onChange(e)
                }}
                onBlur={onBlur}
                onInvalid={onInvalid}
                required={required}
                disabled={disableInputs}
                className={`${fieldClassName} ${isLoading ? 'animate-pulse' : ''}`}
            >
                <option value="">-- Select an option --</option>
                {options.map((option, index) => (
                    <option key={index} value={option}>
                        {option}
                    </option>
                ))}
            </select>
            <FieldError message={errorMessage} />
            {helperText && (
                <div className="text-xs text-gray-500 mt-1">
                    {helperText}
                </div>
            )}
        </div>
    )
}

export default memo(MultiSelectInput)
